import { useQuery } from "@tanstack/react-query";

import { supabase } from "@/shared/lib/supabase";
import { KEY_DOCUMENT_SLOTS, KEY_DOCUMENT_TYPES } from "@/shared/constants/keyDocuments";

export const KEY_DOC_TOTAL = KEY_DOCUMENT_SLOTS.length;

function slotIdForDocType(type: string): string | undefined {
  return KEY_DOCUMENT_SLOTS.find((slot) => slot.documentTypes.some((docType) => docType === type))
    ?.id;
}

export function useKeyDocCount(estateId: number | undefined) {
  const { data: keyDocCount = 0 } = useQuery({
    queryKey: ["keyDocCount", estateId],
    queryFn: async () => {
      const { data } = await supabase
        .from("estate_documents")
        .select("document_type")
        .eq("estate_id", estateId!)
        .in("document_type", KEY_DOCUMENT_TYPES);
      const slots = new Set(data?.map((d) => slotIdForDocType(d.document_type)).filter(Boolean));
      return slots.size;
    },
    enabled: !!estateId,
  });

  return { keyDocCount, keyDocTotal: KEY_DOC_TOTAL };
}
